const HIDE_STYLE_ID = 'nets-hide-cya11y-button';

export const findAccessiYesButton = () => {
  const container = document.querySelector('#cya11y-container');
  const root = container?.shadowRoot;

  return root?.querySelector('.cya11y-menu-btn') || null;
};

const hideAccessiYesButton = () => {
  const container = document.querySelector('#cya11y-container');
  const root = container?.shadowRoot;
  const widgetIcon = root?.querySelector('.cya11y-widget-icon');
  const widgetButton = root?.querySelector('.cya11y-menu-btn');

  if (!root || !widgetIcon || !widgetButton) {
    return false;
  }

  if (!root.querySelector(`#${HIDE_STYLE_ID}`)) {
    const style = document.createElement('style');
    style.id = HIDE_STYLE_ID;
    style.textContent = `
      .cya11y-widget-icon {
        position: absolute !important;
        width: 1px !important;
        height: 1px !important;
        overflow: hidden !important;
        clip-path: inset(50%) !important;
        white-space: nowrap !important;
        pointer-events: none !important;
      }
    `;
    root.appendChild(style);
  }

  widgetButton.setAttribute('tabindex', '-1');
  widgetButton.setAttribute('aria-hidden', 'true');
  return true;
};

export default function initAccessibilityWidget() {
  let attempts = 0;
  const maxAttempts = 40;

  const tryHideButton = () => {
    if (hideAccessiYesButton() || attempts >= maxAttempts) {
      return;
    }

    attempts += 1;
    window.setTimeout(tryHideButton, 250);
  };

  tryHideButton();

  const observer = new MutationObserver(() => {
    hideAccessiYesButton();
  });
  observer.observe(document.body, { childList: true, subtree: true });
}
